<!--
 * @Author: yanmin
 * @Description: 支付页面
 * @Date: 2022-04-14 14:42:50
 * @LastEditTime: 2025-07-14 11:52:33
 * @FilePath: \yf_car\src\views\pay.vue
-->
<!--  -->
<template>
  <div>
    <div class="g-white-box g-stop-introd pay-info">
    <div>
        <img src="../assets/images/tips-img-payok.png" class="pay-icon" />
     </div>
     <div class="pay-text">
       支付成功
    </div>
    <!-- <div class="g-foot-box">
      <p class="u-updata-tips">若不抬杆，请拨打停车场服务热线</p> -->
    <!-- <footdiv></footdiv> -->
    <!-- </div> -->
    </div>

    <div class="g-white-box g-stop-introd">
      <van-skeleton :row="5" :loading="loadings" :row-width="['100%', '100%', '100%', '100%']"> </van-skeleton>
      <ul class="g-list-two" v-if="!loadings">
        <li>
          <strong>计费金额：</strong>

          <b>
            ¥{{
              ruleDetails.stoping_amount
            }}
          </b>
        </li>
        <li>
          <strong>代缴金额：</strong><b>¥{{ ruleDetails.company_deduction_amount  }}</b>
        </li>
        <li>
          <strong>优惠券金额：</strong><b> ¥{{ ruleDetails.preferential_money   }} </b>
        </li>
        <li><strong>实付金额：</strong><b style="color: red"> ¥{{ ruleDetails.real_payed_money   }} </b></li>
        <!-- <li><strong>已付金额</strong><b>¥{{}}</b></li> -->
        <!-- <li v-if="company_deduction_amount">
          <strong>企业代缴</strong><b>¥{{ company_deduction_amount }}</b>
        </li> -->
      </ul>
    </div>
    <div class="offline-btn" v-if="!is_online">
      <van-button type="primary" class="g-btn f-btncolor-blue" @click="openRamp">
        <img class="laya-png" src="../assets/images/laya.png" /> 点击出场
      </van-button>
    </div>
  </div>
</template>

<script>
import {getIsOnline, getBluetoothUrl, getConsumeInfo} from '@/api/base'
import {Toast, Button} from 'vant'
export default {
  components: {
    Button,
    Toast,
  },
  data() {
    return {
      title: '停车时长 12小时3分钟',
      is_online: 1,
      ruleDetails: {},
      loadings: true,
      // formData: {
      //     passageway_id: 236,
      //     smartpark_id: '',
      //     consume_id: '',
      //     from: 'wx',
      //     h5_url: 'http://192.168.80.111/pay'
      // }
    }
  },
  computed: {},
  watch: {},
  methods: {
    async init() {
      this.is_online = (
        await getIsOnline({
          passageway_id: this.$route.query.passageway_id,
        })
      ).data.is_online
    },
    async getInfo() {
      this.loadings = true
      try {
        const {data} = await getConsumeInfo({consume_id: this.$route.query.consume_id})
        console.log(11, data)
        this.ruleDetails = data
        this.loadings = false
      }
      catch(error) {
        this.loadings = false
      }
    },
    async openRamp() {
      try {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        const {data} = await getBluetoothUrl({
          passageway_id: this.$route.query.passageway_id,
          car_number: this.$route.query.car_number,
        })
        location.href = data.url
        Toast.clear()
      } catch (error) {
        Toast(error.msg)
      }
    },
  },
  created() {
    // window.addEventListener('popstate', this.popstate, false)
    this.init()
    this.getInfo()
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
.g-tips-box {
  width: 100%;
  height: auto;
  background: #fff;
  display: block;
  overflow: hidden;
  padding: 1.14rem 0;
  margin: 0;
}

.g-tips-box img {
  width: 2.6rem;
  height: auto;
  margin: 0 auto;
  display: block;
  overflow: hidden;
}
.pay-icon {
  width: 3rem;
}
.pay-info {
  text-align: center;
  font-size: 0.5rem;
}
.pay-text{
  height: 1rem;
  line-height: 1rem;
  font-weight: bold;
}
.g-tips-box strong {
  width: 100%;
  height: 0.44rem;
  line-height: 0.44rem;
  font-size: 0.38rem;
  font-weight: normal;
  color: #222;
  text-align: center;
  margin: 0.38rem 0 0;
  display: block;
  overflow: hidden;
}
.offline-btn-tips {
  font-size: 0.24rem;
  text-align: center;
  margin: 0.3rem 0 -0.2rem 0;
  font-weight: bold;
}
.laya-png {
  width: 0.3rem !important;
  height: 0.3rem !important;
  vertical-align: middle;
  // margin-top: -2px !important;
}
.offline-btn .van-button__text {
  display: flex;
  align-items: center;
}
</style>
